import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import { Title, Text } from '../elements';
import { useText } from 'common/hooks';

const deps = {
  error: state.account.joinCampaign.joiningError,
};

export function ErrorMessage({
  error,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  const errorPath = `errors.${error}`;

  return (
    <>
      <Title>{t('account.join_campaign.error.title')}</Title>
      <Text>{t.has(errorPath) ? t(errorPath) : t('errors.error')}</Text>
    </>
  );
}

export default connect(deps, ErrorMessage);
